// extracted by mini-css-extract-plugin
module.exports = {"task-list":"styles_task-list__-0eNI","custom_accent_assign_button":"styles_custom_accent_assign_button__3Xr0O","custom-width-task":"styles_custom-width-task__1VnvB"};